import { ExpensesRootPageQuery } from 'generated/resources/graphql'

import { PayrollExpensableDetail } from 'modules/expenses/types/PayrollExpensableDetail'

export const usePayroll = (
  canReimburseThroughPayroll: boolean,
  data?: ExpensesRootPageQuery['payroll']
): PayrollExpensableDetail => {
  if (!canReimburseThroughPayroll || !data) {
    return {
      categories: [],
      currentPeriodOpen: false,
    }
  }

  const categories =
    data.expensesCategoriesContractsTaxonomiesConnection.nodes.map((t) => t.expensesCategoryId) ||
    []

  const currentPeriodOpen =
    data.currentDefaultPolicyPeriodsConnection?.nodes?.some((period) => period.openToSupplements) ||
    false

  return {
    categories,
    currentPeriodOpen,
  }
}
